export var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS["CLEAR_INLINE_SUGGESTION"] = "CLEAR_INLINE_SUGGESTION";
  ACTIONS["UPDATE_INLINE_SUGGESTION"] = "UPDATE_INLINE_SUGGESTION";
  ACTIONS["UPDATE_LOCALE"] = "UPDATE_LOCALE";
  return ACTIONS;
}({});